import HttpService from "./httpService";
import { ShippingPartner } from "../types/shippingPartner";

export interface ParcelHubWarehouse {
    warehouse_id?: number | string;
    name?: string;
    warehouse_name?: string;
    address?: string;
    city?: string;
    state?: string;
    pincode?: string;
    phone?: string;
    email?: string;
}

export class ShippingService {

    static create = (data: { type: string; enabled?: boolean; config?: any }) => {
        return HttpService.post<ShippingPartner>('/shipping-partners', data);
    }

    static list = () => {
        return HttpService.get<ShippingPartner[]>('/shipping-partners');
    }

    static update = (id: string, data: Partial<ShippingPartner>) => {
        return HttpService.patch(`/shipping-partners/${id}`, data);
    }

    static remove = (id: string) => {
        return HttpService.delete(`/shipping-partners/${id}`);
    }

    // Convenience methods for specific operations
    static enableDisableShippingPartner = (shippingPartnerId: string, enabled: boolean) => {
        return HttpService.patch(`/shipping-partners/${shippingPartnerId}`, { enabled });
    }

    // Warehouses live in the Parcel Hub account, so they can only be listed once
    // the partner has been saved with a valid API key and account email.
    static listParcelHubWarehouses = (shippingPartnerId: string) => {
        return HttpService.get<ParcelHubWarehouse[]>(`/shipping-partners/${shippingPartnerId}/parcelhub-warehouses`);
    }
}
